export var Groups = {
  1: {
    order: ["/reading"],
  },
  2: {
    order: ["/game"],
  },
};

// !-- CONTROL STUDY WITH UNLV --!
// Index[0] determines which tasks user's are performing
//   - 1 = Reading
//   - 2 = Gaming
// Index[1] determines the MSN the user will see
//   - 1 = Low fear, low efficacy
//   - 2 = Low fear, high efficacy
//   - 3 = High fear, low efficacy
//   - 4 = High fear, high efficacy
// Index[2] determines when the user will see the MSN
//   - 1 = During Task
//   - 2 = After Task
// Index[3] is disabled and left at 1
//  - [Used to control which button was dominantly highlighted]
// Index[4] is the group number
//  - 16 groups
// index[5] is disabled and left at 1 
//  - [Used to control whether or not the user had a postpone button]

export var msnGroups = {
    // Reading
    1: {
      order: [1, 1, 1, 1, 1, 1],
    },
  
    // Reading
    2: {
      order: [1, 2, 1, 1, 2, 1],
    },
  
    //Reading
    3: {
      order: [1, 3, 1, 1, 3, 1],
    },
  
    //Reading
    4: {
      order: [1, 4, 1, 1, 4, 1],
    },
  
    //Reading
    5: {
      order: [1, 1, 2, 1, 5, 1],
    },
  
    //Reading
    6: {
      order: [1, 2, 2, 3, 6, 1],
    },
  
    //Reading
    7: {
      order: [1, 3, 2, 1, 7, 1],
    },
  
    //Reading
    8: {
      order: [1, 4, 2, 1, 8, 1],
    },
  
    // GAMING
  
    //Gaming
    9: {
      order: [2, 1, 1, 1, 9, 1],
    },
  
    //Gaming
    10: {
      order: [2, 2, 1, 1, 10, 1],
    },
  
    //Gaming
    11: {
      order: [2, 3, 1, 1, 11, 1],
    },
  
    //Gaming
    12: {
      order: [2, 4, 1, 1, 12, 1],
    },
  
    //Gaming
    13: {
      order: [2, 1, 2, 1, 13, 1],
    },
  
    //Gaming
    14: {
      order: [2, 2, 2, 1, 14, 1],
    },
  
    //Gaming
    15: {
      order: [2, 3, 2, 1, 15, 1],
    },
  
    //Gaming
    16: {
      order: [2, 4, 2, 1, 16, 1],
    },
};

export var timeGroups = {
  1: {
    delay: 25000,
  },
  2: {
    delay: 50000,
  }
};

function shuffleNotif(array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

//3 (Long MSN without how and why, short MSN with how and why, short MSN without how and why buttons)
// TODO: Should this be changed to 3?
var notData = [99];
export var notifData = notData;

// UNLV concerned about data not random, though I think this is just typical random clumping, this is ripped
// from stack overflow but theoretically should add another layer of "pseudorandomness" to this equation
// mmsnGroups[Math.floor(Math.pow(10,14)*Math.random()*Math.random())%(16-1+1)+1].order;
export var randomControlGroup = msnGroups[1].order;
console.log("Settings: ", randomControlGroup);

// Game is 1, reading is 0
export var randTask = randomControlGroup[0];
if (randTask == 1) {
  localStorage.setItem("task_type", "0")
} else if (randTask == 2) {
  localStorage.setItem("task_type", "1");
}
console.log("Random Task: ", randTask);
export var randNotif = randomControlGroup[1];
// high is 1, low is 0
if (randNotif === 1) {
  localStorage.setItem("threat", "0")
  localStorage.setItem("efficacy", "0")
} else if (randNotif === 2){
  localStorage.setItem("threat", "0")
  localStorage.setItem("efficacy", "1")
} else if (randNotif === 3) {
  localStorage.setItem("threat", "1")
  localStorage.setItem("efficacy", "0")
} else if (randNotif === 4) {
  localStorage.setItem("threat", "1")
  localStorage.setItem("efficacy", "1")
}
console.log("Random notification: ", randNotif);

// if during task its 1, if after its 0
export var randDelay = randomControlGroup[2];
if (randDelay == 1) {
  localStorage.setItem("task_time", "1")
} else if (randDelay == 2) {
  localStorage.setItem("task_time", "0");
}
console.log("Random delay: ", randDelay);
export var randButtonHighlight = randomControlGroup[3];
console.log("Random Highlight: ", randButtonHighlight);
export var randGroup = randomControlGroup[4];
console.log("Random Group: ", randGroup);
export var randButtons = randomControlGroup[5];
console.log("Random Buttons: ", randButtons);

// Date function that formats like UNLV wants
export function UNLVDate() {
  const regularDate = new Date();
  var date;
  var formatMonth, formatDay, formatHour, formatMin, formatSec;
  // if less than 10 we need an extra 0
  if (parseInt(regularDate.getUTCMonth())+1 < 10){
    formatMonth = regularDate.getUTCMonth();
    formatMonth = parseInt(formatMonth)+1
    formatMonth = "0"+formatMonth
  } else {
    formatMonth = regularDate.getUTCMonth();
    formatMonth = parseInt(formatMonth)+1
  }
  if (regularDate.getUTCDate() < 10) {
    formatDay = "0"+regularDate.getUTCDate();
  } else {
    formatDay = regularDate.getUTCDate();
  }
  if (regularDate.getUTCHours() < 10) {
    formatHour = "0"+regularDate.getUTCHours();
  } else {
    formatHour = regularDate.getUTCHours();
  }
  if (regularDate.getUTCMinutes() < 10) {
    formatMin = "0"+regularDate.getUTCMinutes();
  } else {
    formatMin = regularDate.getUTCMinutes();
  }
  if (regularDate.getUTCSeconds() < 10) {
    formatSec = "0"+regularDate.getUTCSeconds();
  } else {
    formatSec = regularDate.getUTCSeconds();
  }

  // fullyear-month-day hours:minutes:seconds ALL IN UTC 24 hour format
  var date = "'"+regularDate.getUTCFullYear()+"-"+formatMonth+"-"+formatDay+" "+
              formatHour+":"+formatMin+":"+formatSec;
  console.log("Platform just recieved date: "+date);
  return date;
}

// By defauly the privacy access is on so start at on a.k.a. one
localStorage.setItem("security_setting","1")

export const toDegrees = (radians) => (radians * 180) / Math.PI;
export const toRadians = (degrees) => (degrees * Math.PI) / 180;

export const getRange = (length) => [...Array(length).keys()];
export const getRandomFrom = (...args) => args[Math.floor(Math.random() * args.length)];
export const flatten = (arrays) => arrays.reduce((acc, row) => [...acc, ...row], []);
export const withoutElement = (array, element) => array.filter((e) => e !== element);
export const updateElement = (array, oldElement, newElement) => array.map((e) => (e === oldElement ? newElement : e));

export const registerListener = (eventName, handler) => {
  window.addEventListener(eventName, handler);
  return () => window.removeEventListener(eventName, handler);
};
